<header class="header" motif-header>
  <button (click)="toggleShowMenu()" aria-label="Toggle menu" motif-header-menu position="left"></button>
  <a class="header_logo" [href]="fullHomeRoute" aria-label="EY Logo" position="left">
    <img alt="EY Logo" height="24" [ngSrc]="logoURL()" width="24" />
    <h1 class="header_title">
      {{ 'common.header.app-title' | translate }}
    </h1>
  </a>

  <app-companies-dropdown position="right" />

  <app-user-profile-dropdown position="right" />
</header>
